import { Link } from "react-router-dom";

export const Logo = ({ className = "", imgClassName = "h-12 sm:h-14", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="site-logo"
    aria-label="One World of Sports — home"
    className={`inline-flex items-center ${className}`}
  >
    <img
      src="/owos-logo-badge.png"
      alt="One World of Sports"
      className={`${imgClassName} w-auto object-contain`}
    />
  </Link>
);
